module.exports = __webpack_public_path__ + "assets/img/w-c-8.9df30800.png";